module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "scrollable"
  }, [_c('h3', {
    staticClass: "section-title"
  }, [_vm._v("Рецепты")]), _vm._v(" "), _c('div', {
    staticClass: "text-container text-container-relative"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "recipes-btn"
  }, [_c('li', [_c('a', {
    staticClass: "btn",
    class: {
      'recipes-active': (_vm.type == 'meat')
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleType('meat')
      }
    }
  }, [_vm._v("мясо")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "btn",
    class: {
      'recipes-active': (_vm.type == 'no-meat')
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleType('no-meat')
      }
    }
  }, [_vm._v("без мяса")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "btn",
    class: {
      'recipes-active': (_vm.type == 'all')
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleType('all')
      }
    }
  }, [_vm._v("всё")])])])]), _vm._v(" "), _c('div', {
    staticClass: "recipes-wrap"
  }, [_c('div', {
    staticClass: "recipes-container"
  }, [_c('div', {
    staticClass: "clear"
  }, [_c('div', {
    staticClass: "recipes-col"
  }, _vm._l((_vm.recipes), function(rec, index) {
    return (index % 2 == 0) ? _c('Recipe', {
      key: index,
      attrs: {
        "recipe": rec,
        "index": index
      }
    }) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "recipes-col"
  }, _vm._l((_vm.recipes), function(rec, index) {
    return (index % 2 != 0) ? _c('Recipe', {
      key: index,
      attrs: {
        "recipe": rec,
        "index": index
      }
    }) : _vm._e()
  }))]), _vm._v(" "), _c('div', {
    staticClass: "recipe-button"
  }, [_c('a', {
    staticClass: "btn-top",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.up($event)
      }
    }
  }, [_vm._v("в начало "), _c('Arrow')], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-main text-main-recipes"
  }, [_c('p', [_vm._v("Мы собрали для вас 20 лучших рецепты блюд, приготовленных на гриле. Выбери любимый рецепт или порадуй\n            близких и друзей умением готовить разнообразные и вкусные блюда на пикнике!")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67d839af"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Recipes.vue
// module id = 102
// module chunks = 0